<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="visible"
    width="700px"
    @close="$emit('update:show', false)"
    :close-on-click-modal="false"
  >
    <el-form
      ref="form"
      size="small"
      :label-width="model.category == 6 ? '110px' : '100px'"
      :model="model"
      :rules="rules"
      :class="{ 'fix-width': model.category != 6 }"
      :inline="model.category != 6"
    >
      <el-form-item
        :label="model.category == 5 ? '使用日期' : '维修日期'"
        prop="used_date"
      >
        <el-date-picker
          :class="{ long: model.category == 6 }"
          :picker-options="{
            disabledDate(time) {
              return time.getTime() > Date.now()
            },
          }"
          v-model="model.used_date"
          type="date"
          placeholder="选择日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item
        label="成品编号"
        prop="product_id"
        v-if="model.category == 6"
      >
        <ProductSelect
          v-model="model.product_id"
          :category="model.product_category"
        ></ProductSelect>
      </el-form-item>
      <el-form-item label="使用次数" prop="usage" v-if="model.category == 6">
        <el-select v-model="model.usage" class="long">
          <el-option
            :key="n"
            :value="n"
            v-for="n in 30"
            :label="`第${n}次`"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="维修更换情况"
        class="long"
        v-if="model.category == 6"
      >
        <el-input v-model="model.inspection" type="textarea"></el-input>
      </el-form-item>
      <el-form-item
        label="处理措施和结果"
        class="long"
        v-if="model.category == 6"
      >
        <el-input v-model="model.solution" type="textarea"></el-input>
      </el-form-item>
      <el-form-item
        v-if="model.category == 5"
        label="工作时长"
        prop="used_hour"
      >
        <el-input-number v-model="model.used_hour"></el-input-number>
      </el-form-item>
      <el-form-item
        :label="param.label"
        v-for="param in model.used_extra"
        :key="param.key"
      >
        <el-input v-model="param.value"></el-input>
      </el-form-item>
      <el-form-item label="备注" class="long">
        <el-input v-model="model.remark" type="textarea"></el-input>
      </el-form-item>
      <el-form-item label="图片" class="long">
        <FileUpload v-model="model.imgs" v-if="visible"></FileUpload>
      </el-form-item>
      <el-form-item label="视频" class="long">
        <VideoUploader v-model="model.videos" v-if="visible"></VideoUploader>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="submiting"
        @click="submitForm"
        >确认</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { itemRecordNew, itemRecordUpdate } from '@/service/getData'

export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dialogTitle() {
      let title = this.model.id ? '编辑' : '添加'
      title += this.model.category == 5 ? '使用记录' : '维修记录'
      return title
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      visible: this.show,
      submiting: false,
      rules: {
        used_date: [{ required: true, message: '请选择日期', trigger: 'blur' }],
        // usage: [{ required: true, message: '请选择使用次数', trigger: 'blur' }],
        used_hour: [
          { required: true, message: '工作时长不能为空', trigger: 'change' },
          {
            type: 'number',
            min: 1,
            max: 100000,
            message: '工作时长不能为0',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submiting = true

          let isUpdate = this.model.id > 0
          let res = {}
          if (isUpdate) {
            res = await itemRecordUpdate(this.model)
          } else {
            res = await itemRecordNew(this.model)
          }

          this.submiting = false
          if (res.code == 0) {
            this.$emit(`${isUpdate ? 'updated' : 'created'}`, res.data)
            this.visible = false
          }
        }
      })
    },
  },
}
</script>